import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import theme from "./Theme";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";

import { setToken } from "./services/Api";

import Home from "./modules/Home";
import Login from "./modules/Login/Login";
import RecoverPassword from "./modules/Login/RecoverPassword";
import ResetPassword from "./modules/Login/ResetPassword";

import { CardapioImpressao } from "./modules/Nutricao";

import { loginRoutes, PrivateRoute, Auth as AuthProvider } from "elentari";

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <AuthProvider withUser={(user) => setToken(user.token)}>
            <Router>
              <Switch>
                <Route path={loginRoutes.login} component={Login} />
                <Route
                  path={loginRoutes.recoverPassword}
                  component={RecoverPassword}
                />
                <Route
                  path={loginRoutes.resetPassword}
                  component={ResetPassword}
                />
                <Route
                  path="/cardapios/:id/print"
                  component={CardapioImpressao}
                />
                <PrivateRoute path="/" component={Home} />
              </Switch>
            </Router>
          </AuthProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

export default App;
